import React from 'react';
import { Dialog } from '@mui/material';
import Basic from '~/containers/Page_Main/Page_InfoManagement/Page_BasicInfo/Basic';
import Agree from '~/containers/Page_Main/Page_InfoManagement/Page_BasicInfo/Agree';
import Project from '~/containers/Page_Main/Page_InfoManagement/Page_BasicInfo/Project';
import Boat from '~/containers/Page_Main/Page_InfoManagement/Page_BasicInfo/Boat';
import Pier from '~/containers/Page_Main/Page_InfoManagement/Page_BasicInfo/Pier';
import Original_Equity from '~/containers/Page_Main/Page_InfoManagement/Page_BasicInfo/Original_Equity';
import Last_Equity from '~/containers/Page_Main/Page_InfoManagement/Page_BasicInfo/Last_Equity';

const Contain = ({ current_id }) => (
  <div style={{ width: '90%', height: '90%', backgroundColor: 'white', overflow: 'auto', borderRadius: 30 }}>
    <Basic windId={current_id} />
    <Agree windId={current_id} />
    <Project windId={current_id} />
    <Boat windId={current_id} />
    <Pier windId={current_id} />
    <Original_Equity windId={current_id} />
    <Last_Equity windId={current_id} />
  </div>
);

const App = ({ current_id, onClose = () => {} }) => (
  <Dialog
    open={!!current_id}
    onClose={onClose}
    PaperComponent={Contain}
    PaperProps={{ current_id }}
  />
);

export default App;
